import styled from 'styled-components';
import { Modal as ModalRoot, Select } from '@indigo-ag/component-module';

export const Modal = styled(ModalRoot)`
  min-width: 53.75rem;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: right;
  gap: 0.5rem;
  padding: 1rem;
`;

export const FormContainer = styled.div`
  min-height: 230px;
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
`;

export const ConditionalSelect = styled(Select)`
  min-width: 28rem;
`;

export const ConditionalButton = styled.button`
  height: 34px;
  cursor: pointer;
  border: none;
  margin: 0.25rem;
  padding-top: 0.375rem;
  vertical-align: bottom;
  color: #cd853f;
  border-bottom: 0.25rem solid transparent;
  background-color: transparent;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.2s;

  &:hover {
    color: #8b4513;
    border-bottom: 0.25rem solid #cd853f;
  }
`;
